import Vue from 'vue'
import Router from 'vue-router'
// import Index from '@/pages/index/index'
// import ResourceBank from "@/pages/resourceBank/index"
// import ResourceDetail from "@/pages/ResourceDetail/index"
const Index = () => import('../pages/index/index.vue')
const ResourceBank = () => import("../pages/resourceBank/index.vue")
const ResourceDetail = () => import("../pages/resourceDetail/index.vue")
// 购物车列表
const ShopCartList = () => import("../pages/shoppingCart/shopcart.vue")
// 企业实名
const EnterPriseAuthentication = () => import('@/components/realname/authentication/enterpriseAuthentication1.vue')
// 企业法人信息
const EnterPriseAuthenticationMessage = () => import('@/components/realname/authentication/enterpriseAuthentication2.vue')
// const AllPictures = () => import('@/components/pictures/allPictures/allPictures')
const MyUser = () => import('@/pages/mycenter/myUserLayout.vue')
const MyRightCenter = () => import('@/pages/mycenter/myCopyrightLayout.vue')
const MyWorks = () => import('@/pages/mycenter/wemedia/myworks.vue')
const MyCopyrighWorks = () => import('@/pages/mycenter/copyright/myWork.vue')
const AddNew = () => import('@/pages/addNew/index.vue')
//AuthManage
const AuthManage = () => import('@/pages/mycenter/copyright/authManage.vue')
const DataStaticsHosting = () => import('@/pages/mycenter/wemedia/dataStatisticsHosting.vue')
const ProfitAnalyze = () => import('@/pages/mycenter/copyright/profitAnalyze.vue')
const TortAnalyze = () => import('@/pages/mycenter/copyright/tortAnalyze.vue')
const ApplicationRecord = ()=> import('@/pages/mycenter/wemedia/applicationRecord.vue')
const MyAblility = () => import('@/pages/mycenter/wemedia/myablility.vue')
const Instrument = () => import('@/pages/instrument/instrument.vue')
const Agreement = () => import('@/pages/agreement/index.vue')

// 实名认证成功审核中失败页面
const AuthSucceOrErr = () => import('@/pages/mycenter/authenticationSuOrerr.vue')
Vue.use(Router)

export default new Router({
  routes: [
    {path: '/', name:'index', component: Index},
    {path: '/resource', name:'resource', component: ResourceBank},
    {path: '/detail', name:'detail', component: ResourceDetail},
    {path: '/shopcart', name:'shopcart', component: ShopCartList},
    {path: '/addNew', name:'addNew', component: AddNew},
    // {path: '/instrument', name:'instrument', component: Instrument},
    {path: '/agreement', name:'agreement', component: Agreement},
    {
      path:'/mycenter',
      name:'Mycenter',
      component: MyUser,
      children: [
        {
          path: 'myworks',
          name: 'MyWorks',
          component: MyWorks
        },
        {
          path: 'datastaticshosting',
          name: 'data_statistics_hosting',
          component: DataStaticsHosting
        },
        {
          path: 'myablility',
          name: 'MyAblility',
          component: MyAblility
        },
        {
          path: 'applicationRecord',
          name: 'application_record',
          component: ApplicationRecord
        },
        {
          path: 'enterpriseauthentication', 
          name:'enterpriseauthentication', 
          component: EnterPriseAuthentication
        },
        {
          path: 'enterpriseAuthentication2', 
          name:'enterpriseAuthentication2', 
          component: EnterPriseAuthenticationMessage
        },
        {
          path:'authSentucceor',
          name:'authSentucceor',
          component:AuthSucceOrErr
        }
      ]
    },
    {
      path:'/mycopyrightcenter',
      name:'mycopyrightcenter',
      component: MyRightCenter,
      children: [
        {
          path: 'myCopyrighWorks',
          name: 'myCopyrighWorks',
          component: MyCopyrighWorks
        },
        {
          path: 'authManage',
          name: 'authManage',
          component: AuthManage
        },
        {
          path: 'profitanalyze',
          name: 'ProfitAnalyze',
          component: ProfitAnalyze
        },
        {
          path: 'enterpriseauthentication', 
          name:'enterpriseauthentication', 
          component: EnterPriseAuthentication
        },
        {
          path: 'tortanalyze',
          name: 'TortAnalyze',
          component: TortAnalyze
        },
        {
          path:'authSentucceor',
          name:'authSentucceor',
          component:AuthSucceOrErr
        }
      ]
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js